import timm from 'timm';

import { Types } from 'app/actions/app';
import utils from 'app/reducers/utils';

const initialState = {
  meta: {},
  isServer: true,
  openModals: {}, // {modalKey: boolean}
  cfLocation: null,
};

const reducer = utils.createReducer(initialState, {

  [Types.SET_META]: (state, {keyVals}) => {
    return {...state,
      meta: {
        ...keyVals,
      },
    };
  },

  [Types.CLEAR_IS_SERVER]: (state, action) => {
    return {...state,
      isServer: false,
    };
  },

  [Types.SET_MODAL_IS_OPEN]: (state, action) => {
    const openModals = {...state.openModals};
    if (action.isOpen) {
      openModals[action.key] = true;
    } else {
      delete openModals[action.key];
    }
    return {...state,
      openModals,
    };
  },

  [Types.SET_CF_LOCATION]: (state, action) => {
    return {...state, cfLocation: action.cfLocation};
  },

});

export default reducer;
